export default __webpack_public_path__ + "static/signup-backgrond-49f0217309ca9579acbaf4592942efd3.png";